import { Link, useRouter } from "@shared/client/navigation";
import { useTransition } from "react";
import { Button } from "@shared/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@shared/components/ui/select";

const PROVIDERS = [
  { value: "all", label: "Tous les fournisseurs" },
  { value: "deepseek", label: "DeepSeek" },
  { value: "openai", label: "OpenAI" },
  { value: "bedrock", label: "Amazon Bedrock" },
  { value: "perplexity", label: "Perplexity" },
  { value: "exa", label: "Exa" },
  { value: "jina", label: "Jina Reader" },
  { value: "fetch", label: "Récupération directe" },
];

const KINDS = [
  { value: "all", label: "Tous les types" },
  { value: "analysis", label: "Analyse (agent)" },
  { value: "enrichment_org", label: "Enrichissement — organisation" },
  { value: "enrichment_contact", label: "Enrichissement — interlocuteur" },
  { value: "enrichment_person_search", label: "Recherche web — personne" },
  { value: "enrichment_person_synthesis", label: "Synthèse — personne" },
  { value: "enrichment_osint_search", label: "Recherche OSINT — organisation" },
  { value: "enrichment_osint_synthesis", label: "Synthèse OSINT — organisation" },
  { value: "lead_email", label: "E-mail d’approche — rédaction" },
  { value: "prospect_email", label: "E-mail de prospection — rédaction" },
  { value: "prospect_review", label: "E-mail de prospection — garde-fou" },
  { value: "prospect_reply", label: "Prospection — classement d’une réponse" },
  { value: "source_search", label: "Recherche — canaux de données" },
  { value: "source_read", label: "Lecture — page publique" },
];

const STATUSES = [
  { value: "all", label: "Tous les statuts" },
  { value: "success", label: "Succès" },
  { value: "error", label: "Erreur" },
];

/** Filtres des traces d'agents — appliqués à la sélection, conservés dans l'URL. */
export function TraceFilters({
  provider,
  kind,
  status,
  run,
}: {
  provider: string;
  kind: string;
  status: string;
  run: string;
}) {
  const router = useRouter();
  const [, startTransition] = useTransition();

  function apply(next: Partial<Record<"provider" | "kind" | "status", string>>) {
    const merged = { provider, kind, status, ...next };
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(merged)) {
      if (value && value !== "all") params.set(key, value);
    }
    if (run) params.set("run", run);
    startTransition(() => router.push(`/admin/agents${params.size ? `?${params}` : ""}`));
  }

  return (
    <div className="flex flex-1 flex-wrap items-center gap-3">
      <Select onValueChange={(value) => apply({ provider: value })} value={provider}>
        <SelectTrigger aria-label="Fournisseur" className="h-9 text-xs font-semibold">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {PROVIDERS.map((item) => <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>)}
        </SelectContent>
      </Select>

      <Select onValueChange={(value) => apply({ kind: value })} value={kind}>
        <SelectTrigger aria-label="Type d’appel" className="h-9 text-xs font-semibold">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {KINDS.map((item) => <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>)}
        </SelectContent>
      </Select>

      <Select onValueChange={(value) => apply({ status: value })} value={status}>
        <SelectTrigger aria-label="Statut" className="h-9 text-xs font-semibold">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {STATUSES.map((item) => <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>)}
        </SelectContent>
      </Select>

      {run && (
        <Button asChild size="sm" variant="ghost">
          <Link href="/admin/agents">Voir tous les runs</Link>
        </Button>
      )}
    </div>
  );
}
